// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, push } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import {
  getFirestore, collection, addDoc, getDoc, setDoc, doc, query,
  getDocs, limit, startAfter, deleteDoc, updateDoc, arrayUnion
} from 'firebase/firestore';
import {getStorage,listAll,ref as storageRef, getDownloadURL} from "firebase/storage";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line
const analytics = getAnalytics(app);


//authentication
const auth = getAuth(app);

//create user
const signUp = async (email, password) => {
  return await createUserWithEmailAndPassword(auth, email, password);
}

//Login user
const signIn = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password);
}

//reset password
const resetPassword = async (email) => await sendPasswordResetEmail(auth, email);

//db initialization
const db = getFirestore(app);
//contact us via mail
const contact = async (name, email, subject, message) => {
  let docRef = await addDoc(collection(db, "contacts"), {
    name: name,
    email: email,
    subject: subject,
    message: message,
    time: new Date().getTime()
  });
  return docRef;
}

//get contacts
const findEmails = async () => {
  const contactRef = query(collection(db, "contacts"));
  const documentSnapshots = await getDocs(contactRef);
  const res = [];
  await documentSnapshots.forEach((doc) => {
    res.push(doc.data());
  });
  return res;
}

//user added
const addUser = async (user) => {
  const dbRef = doc(db, "users", user.id);
  return await setDoc(dbRef, user);
}

//get contacts
const findUsers = async () => {
    const userRef = query(collection(db, "users"));
    const documentSnapshots = await getDocs(userRef);
    const res = [];
    await documentSnapshots.forEach((doc) => {
      res.push(doc.data());
    });
  return res;
}

//user teacher
const addTeacher = async (teacher) => {
  const dbRef = doc(db, "teachers", teacher.id);
  return await setDoc(dbRef, teacher);
}
//user mess
const addMess = async (mess) => {
  const dbRef = doc(db, "messes", mess.id);
  return await setDoc(dbRef, mess);
}

//find user
const findUser = async (id) => {
  const dbRef = doc(db, "users", id);
  let ref = await getDoc(dbRef);
  if (ref.exists()) {
    return ref.data();
  }
}

//update user
const updateRequest = async (id, reqDetails) => {
  const dbRef = doc(db, "users", id);
  return await updateDoc(dbRef, {
    request: arrayUnion(reqDetails)
  });
}

//find teacher
const findTeacher = async (id) => {
  const dbRef = doc(db, "teachers", id);
  let ref = await getDoc(dbRef);
  if (ref.exists()) {
    return ref.data();
  }
}

//delete teacher
const deleteTeacher = async (id) => {
  await deleteDoc(doc(db, "teachers", id));
}

//find mess
const findMess = async (id) => {
  const dbRef = doc(db, "messes", id);
  let ref = await getDoc(dbRef);
  if (ref.exists()) {
    return ref.data();
  }
}

//delete mess
const deleteMess = async (id) => {
  await deleteDoc(doc(db, "messes", id));
}

//find teacher
const lastTeacher = "";
const findFirstTeachers = async () => {
  const first = query(collection(db, "teachers"), limit(25));
  const documentSnapshots = await getDocs(first);
  if (documentSnapshots.docs.length > 25) {
    // eslint-disable-next-line
    lastTeacher = documentSnapshots.docs[documentSnapshots.docs.length - 1];
  }
  const res = [];
  await documentSnapshots.forEach((doc) => {
    res.push(doc.data());
  });
  return res;
}

const findNextTeachers = async () => {
  const first = query(collection(db, "teachers"), startAfter(lastTeacher), limit(25));
  const documentSnapshots = await getDocs(first);
  if (documentSnapshots.docs.length > 25) {
    // eslint-disable-next-line
    lastTeacher = documentSnapshots.docs[documentSnapshots.docs.length - 1];
  }
  const res = [];
  await documentSnapshots.forEach((doc) => {
    res.push(doc.data());
  });
  return res;
}

//findTeacherById
const findTeacherById = async (id) => {
  const dbRef = doc(db, "teachers", id);
  let ref = await getDoc(dbRef);
  if (ref.exists()) {
    return ref.data();
  }
}

//filter teacher
const filterTeacher = async (t) => {
  const result = [];
  const teacherRef = collection(db, "teachers");
  const q = query(teacherRef);
  const querySnapshot = await getDocs(q);
  await querySnapshot.forEach((doc) => {
    let data=doc.data();
    if(data.state?.toUpperCase().includes(t.state)
    && data.district?.toUpperCase().includes(t.district)
    && data.pin?.toUpperCase().includes(t.pin)
    && data.name?.toUpperCase().includes(t.name)
    && (data.fees && t.fees ? parseInt(data.fees)<=parseInt(t.fees):true)
    && data.courses?.toUpperCase().includes(t.courses)
    && data.review?.toString().includes(t.review)
    ){
      result.push(data);
    }
  });
  return await result;
}

//find mess
const lastMess = "";
const findFirstMesses = async () => {
  const first = query(collection(db, "messes"), limit(25));
  const documentSnapshots = await getDocs(first);
  if (documentSnapshots.docs.length > 25) {
    // eslint-disable-next-line
    lastMess = documentSnapshots.docs[documentSnapshots.docs.length - 1];
  }
  const res = [];
  await documentSnapshots.forEach((doc) => {
    res.push(doc.data());
  });
  return res;
}

const findNextMesses = async () => {
  const first = query(collection(db, "messes"), startAfter(lastMess), limit(25));
  const documentSnapshots = await getDocs(first);
  if (documentSnapshots.docs.length > 25) {
    // eslint-disable-next-line
    lastMess = documentSnapshots.docs[documentSnapshots.docs.length - 1];
  }
  const res = [];
  await documentSnapshots.forEach((doc) => {
    res.push(doc.data());
  });
  return res;
}

//findMessById
const findMessById = async (id) => {
  const dbRef = doc(db, "messes", id);
  let ref = await getDoc(dbRef);
  if (ref.exists()) {
    return ref.data();
  }
}

//filterMess
const filterMess = async (m) => {
  const result = [];
  const messRef = collection(db, "messes");
  const q = query(messRef);
  const querySnapshot = await getDocs(q);
  await querySnapshot.forEach((doc) => {
    let user=doc.data();
      let filterData=user.details.filter(data=>isMatch(data,m));
      if(filterData.length>0){
        result.push({id:user.id,details:filterData});
      }
  });
  return await result;
}

function isMatch(data,m){
  if(data.state?.toUpperCase().includes(m.state)
  && data.district?.toUpperCase().includes(m.district)
  && data.pin?.toUpperCase().includes(m.pin)
  && data.for?.toUpperCase().includes(m.for)
  && (data.rent && m.rent ? parseInt(data.rent)<=parseInt(m.rent):true)
  && data.type?.toUpperCase().includes(m.type)
  && data.review?.toString().includes(m.review)
  ){
    return true;
  }else{
    return false;
  }
}

//real time database initialization
const rdb = getDatabase(app);
const postListRef = ref(rdb, 'posts');


const createPost = async (post) => {
  const newPostRef = push(postListRef);
  set(newPostRef, post);
}

const updatePost = async (id, post) => {
  set(ref(rdb, 'posts/' + id), post);
}

//storage

const storage = getStorage(app);

const getBanner = async () => {
  const listRef = storageRef(storage, process.env.REACT_APP_BANNER);
  const imageList= await listAll(listRef);
  return imageList.items.map(itemRef=>itemRef.fullPath);
}

const getImage = async (imagepath) => {
  return await getDownloadURL(storageRef(storage,imagepath));
}

export {                                                                                              
  auth, signUp, signIn, sendEmailVerification, resetPassword, contact,findEmails,
  addUser,findUsers, addTeacher, addMess, findUser, findTeacher, findMess,
  findFirstTeachers, findNextTeachers, findTeacherById,filterTeacher,
  findFirstMesses, findNextMesses, findMessById,filterMess,
   deleteMess, deleteTeacher, updateRequest,
  createPost, updatePost, postListRef, getBanner, getImage
}